import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Container, Row, Badge,
} from 'reactstrap';
import EditUserForm from './UserForm';
import Confirm from '../../../shared/components/Confirm';
import {
  fetchUser,
  saveUser,
  setEditUserProfile,
  savePhoto,
  fetchPhoto,
  fetchFormDatas,
  resetUserPassword,
} from '../../../redux/actions/userActions';

import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';

import {
  GruposSanguineos,
  EstadosCiviles,
  Generos,
} from '../../../constants/enums';

import { getCurrentUser } from '../../../helpers/storage';

import LoadingSpinner from '../../../shared/components/LoadingSpinner';

class EditUserContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingFile: false,
      user: null,
    };

    // this.handleOnFilterChange = this.handleOnFilterChange.bind(this);

    // Definimos el objeto inicial fuera para evitar duplicación de código
    this.INITIAL_CATEGORIA = index => ({
      id: 0,
      index,
      escalafon: {
        value: 0, label: '-', parentId: 0, item: null,
      },
      materia: {
        value: 0, label: '', parentId: 0, item: null,
      },
      notas: '',
      removed: false,
    });
  }

  componentDidMount() {
    const { editProfile } = this.props;

    if (editProfile) {
      this.editUserProfile();
      return;
    }

    this.initLoad();
  }

  initLoad = () => {
    this.fetchDatasList();

    const {
      id, history,
    } = this.props;

    if (!id) {
      this.setState({
        user: {
          id: 0,
          arancelCero: false,
          namePhoto: '',
          urlPhoto: null,
          hasManifiestoConformidad: false,
          categoriasProfesores: [],
        },
      });

      return;
    }

    this.setState({
      loading: true,
    });

    fetchUser(id, {
      onSuccess: (dto) => {
        const {
          nacionalidadPais, domicilioPais, trabajoPais,
        } = dto;
        const categoriasProfesores = dto.categoriasProfesores.map((h, index) => ({ ...h, index }));

        const user = {
          ...dto,
          nacionalidad: {
            value: dto.nacionalidadPaisId,
            label: `${nacionalidadPais}`,
          },
          domicilioPais: {
            value: dto.domicilioPaisId,
            label: `${domicilioPais}`,
          },
          trabajoPais: {
            value: dto.trabajoPaisId,
            label: `${trabajoPais}`,
          },
          categoriasProfesores,
        };

        this.setState({
          loading: false,
          user,
          nacionalidadPaisId: dto.nacionalidadPaisId,
          domicilioPaisId: dto.domicilioPaisId,
          trabajoPaisId: dto.trabajoPaisId,
        });

        this.fetchUserPhoto(id);
      },
      onError: (error) => {
        this.setState({
          loading: false,
        });
        if (error && error.status === 404) {
          createErrorMessage('El usuario no existe');
          history.push('/pages/users');
        } else {
          createErrorMessage('Error al intentar cargar los datos del usuario');
        }
      },
    });
  };

  fetchDatasList = () => {
    fetchFormDatas({
      onSuccess: ({ paises, escalafonDocente, materias }) => {
        const mapPaises = paises.map(p => ({
          value: p.id, label: p.nombre,
        }));

        this.setState({
          paises: mapPaises,
          escalafon: escalafonDocente,
          materias,
        });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  };

  editUserProfile = () => {
    this.setState({
      loading: true,
    });

    const { id } = this.props;

    setEditUserProfile({
      id,
      onSuccess: () => {
        this.setState({
          loading: false,
        });

        this.initLoad();
      },
      onError: () => {
        createErrorMessage('Error al intentar establecer la edición del perfil del alumno');
      },
    });
  };

  handleSubmit = (values) => {
    const { photoName, id, hasManifiestoConformidad } = values;
    if (!photoName && id) {
      createWarningMessage('Debe ingresar una foto');

      // return;
    }

    const {
      nacionalidadPaisId,
      domicilioPaisId,
      trabajoPaisId,
    } = this.state;

    const data = {
      ...values,
      hasManifiestoConformidad,
      nacionalidadPaisId,
      domicilioPaisId,
      trabajoPaisId,
    };

    saveUser(data, {
      onSuccess: () => {
        createSuccessMessage('Usuario guardado exitosamente');
        const { history, showProfile } = this.props;

        if (!hasManifiestoConformidad) {
          history.push('/pages/student-subjects/inscription/form');
          return;
        }

        if (!showProfile) {
          history.push('/pages/users');
        }
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Error al intentar guardar el usuario');
        }
      },
    });
  }

  fetchUserPhoto = (id) => {
    this.setState({ loadingFile: true });
    fetchPhoto({
      id,
      onSuccess: (photo) => {
        const { user } = this.state;
        this.setState({
          loadingFile: false,
          user: {
            ...user,
            namePhoto: photo.fileName,
            urlPhoto: window.URL.createObjectURL(photo.file),
          },
        });
      },
      onError: (error) => {
        this.setState({
          loadingFile: false,
        });

        if (error && error.status === 404) {
          if (error.message) {
            createWarningMessage(error.message);
            return;
          }

          createWarningMessage('Error al intentar cargar la foto');
          return;
        }

        createErrorMessage('Error al intentar cargar la foto');
      },
    });
  }

  handleSubmitFoto = (files) => {
    const { id } = this.props;
    this.setState({ loadingFile: true });

    savePhoto({
      id,
      files,
      onSuccess: (photoName) => {
        createSuccessMessage('Foto guardado exitosamente');
        const { user } = this.state;

        this.setState({
          loadingFile: false,
          user: {
            ...user,
            photoName,
          },
        });

        this.fetchUserPhoto(id);
      },
      onError: (error) => {
        this.setState({ loadingFile: false });

        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la foto');
        }
      },
    });
  }

  resetPasswordHandler = () => {
    const {
      user,
    } = this.state;
    const userName = `${user.nombre} ${user.apellido}`;
    Confirm({
      title: 'Restablecer contraseña',
      question: `Estás seguro que deseas restablecer la contraseña para ${userName}?`,
      yesLabel: 'Si, Restablecer contraseña',
      noLabel: 'No, Volver',
      onConfirm: () => {
        resetUserPassword(user.email,
          {
            onSuccess: () => {
              const title = 'Contraseña restablecida exitosamente!';
              const msg = 'Se ha enviado un correo al usuario con información de su nueva contraseña.';
              createSuccessMessage(title, msg);
            },
            onError: (error) => {
              if (error && error.status === 404) {
                createErrorMessage('El usuario no existe');
              } else {
                createErrorMessage('Error al intentar restablecer la contraseña');
              }
            },
          });
      },
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnFilterChange = (objectKey, idKey, value) => {
    const { user } = this.state;
    this.setState({
      [idKey]: value.value,
      user: {
        ...user,
        [objectKey]: value,
      },
    });
  }

  handleAddCategoriasProfesores = () => {
    this.setState((prevState) => {
      // 1. Extraemos de forma segura para evitar errores de "undefined"
      const user = prevState.user || {};
      const categorias = user.categoriasProfesores || [];

      // 2. Calculamos el siguiente índice lógico
      const nextIndex = categorias.length > 0
        ? Math.max(...categorias.map(c => c.index)) + 1
        : 0;

      // 3. Retornamos el estado manteniendo la integridad del objeto 'user'
      return {
        user: {
          ...user,
          categoriasProfesores: [
            ...categorias,
            this.INITIAL_CATEGORIA(nextIndex),
          ],
        },
      };
    });
  };

  handleRemoveCategoriasProfesores = (index) => {
    this.setState((prevState) => {
      const user = prevState.user || {};
      const categorias = user.categoriasProfesores || [];

      return {
        user: {
          ...user,
          categoriasProfesores: categorias.map(cat => (
            cat.index === index
              ? { ...cat, removed: true }
              : cat
          )),
        },
      };
    });
  };

  handleChangeText = ({ target }, index) => {
    const { name, value, type } = target;

    // Caso 1: Actualización de Usuario (Objeto simple)
    if (index === undefined) {
      this.setState(prevState => ({
        user: {
          ...prevState.user,
          [name]: value,
        },
      }));
      return;
    }

    // Caso 2: Actualización de Categorías (Array)
    this.setState((prevState) => {
      const newCategorias = [...prevState.user.categoriasProfesores];
      const val = type === 'number' ? Number(value) : String(value).trim();

      // Extraer la propiedad después del punto, o usar name si no hay punto
      const fieldName = name.includes('.') ? name.split('.')[1] : name;

      newCategorias[index] = {
        ...newCategorias[index],
        [fieldName]: val,
      };

      return {
        user: {
          ...prevState.user,
          categoriasProfesores: newCategorias,
        },
      };
    });
  };

  handleChangeSelect = ({ option, name, index }) => {
    this.setState({ loading: true });

    this.setState((prevState) => {
      const user = prevState.user || {};
      const categorias = user.categoriasProfesores || [];

      // Buscamos y actualizamos el elemento específico de forma inmutable
      const newCategorias = categorias.map((item) => {
        if (item.index === index) {
          return {
            ...item,
            [name]: option, // Actualiza dinámicamente 'escalafon' o 'materia'
          };
        }
        return item;
      });

      return {
        user: {
          ...user,
          categoriasProfesores: newCategorias,
        },
        loading: false,
      };
    });
  };

  handleRadioChanges = (key, value) => {
    this.setState(prevState => ({
      user: {
        ...prevState.user,
        [key]: value,
      },
    }));
  };

  getRolName = () => {
    const { user } = this.state;

    const currentUser = getCurrentUser();

    const Student = 0;
    const Teacher = 1;
    const Employee = 2;
    const Admin = 3;

    if (user.esAlumno) {
      return currentUser.roles.filter(r => r.role === Student).map(role => role.title);
    }

    if (user.esProfesor) {
      return currentUser.roles.filter(r => r.role === Teacher).map(role => role.title);
    }

    if (user.esFuncionario) {
      return currentUser.roles.filter(r => r.role === Employee).map(role => role.title);
    }

    if (user.esAdmin) {
      return currentUser.roles.filter(r => r.role === Admin).map(role => role.title);
    }

    return 'Usuario';
  }

  render() {
    const {
      user,
      paises,
      escalafon,
      materias,
      loading,
      loadingFile,
    } = this.state;
    const {
      id,
      history,
      showProfile,
    } = this.props;

    if (loading || !user || !paises) {
      return <LoadingSpinner />;
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} Ficha del {this.getRolName()}
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              la informaci&oacute;n de la Ficha del {this.getRolName()}
            </h3>
            <h4>
              <Badge color="warning">
                Debe actualizar la ficha antes de inscribirse a las materias
              </Badge>
            </h4>
          </Col>
        </Row>
        <Row>
          <Col md={12}> (
            <EditUserForm
              {...user}
              initialValues={user}
              onSubmit={this.handleSubmit}
              onSubmitFoto={this.handleSubmitFoto}
              resetPasswordHandler={this.resetPasswordHandler}
              onBack={this.handleOnBack}

              onAddItemArray={this.handleAddCategoriasProfesores}
              onDeleteItemArray={this.handleRemoveCategoriasProfesores}

              onFilterChanges={this.handleOnFilterChange}
              onChangeText={this.handleChangeText}
              onChangeSelect={this.handleChangeSelect}

              onRadioChanges={this.handleRadioChanges}

              history={history}

              paises={paises}
              escalafon={escalafon}
              materias={materias}
              gruposSanguineos={GruposSanguineos}
              estadosCiviles={EstadosCiviles}
              generos={Generos}
              showProfile={showProfile}
              loadingFile={loadingFile}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

EditUserContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
  showProfile: PropTypes.bool,
  editProfile: PropTypes.bool,
};
EditUserContainer.defaultProps = {
  showProfile: false,
  editProfile: false,
};

export default EditUserContainer;
